import * as React from "react";

function SvgRemoveUser(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 10.667c7.855 0 14.222 6.367 14.222 14.222 0 7.854-6.367 14.222-14.222 14.222a14.28 14.28 0 01-2.97-.31C6.802 38.595 1.237 37.748.492 36.258c-.907-1.814-.623-6.011 1.354-9.962a14.394 14.394 0 01-.07-1.408c0-5.369 2.975-10.042 7.366-12.463C7.478 6.729 7.943 0 16.033 0c8.376 0 8.416 6.252 6.582 12.295a14.16 14.16 0 00-6.613-1.628H16zm15.572 25.592c-.748 1.496-6.355 2.344-12.611 2.544 5.845-1.237 10.364-6.064 11.144-12.064 1.889 3.818 2.34 7.773 1.467 9.52zM16 38.111c7.302 0 13.222-5.92 13.222-13.222 0-7.303-5.92-13.222-13.222-13.222S2.778 17.587 2.778 24.889 8.698 38.11 16 38.11zm-7.407-19.89v2.223h14.814v-2.222h-4.444V16h-5.926v2.222H8.593zm5.925-.74v.74h2.963v-.74h-2.963zm-4.444 16.296V21.925h11.852v11.852H10.074zm2.222-2.222v-7.407h1.482v7.407h-1.482zm2.963-7.407v7.407h1.482v-7.407h-1.482zm2.963 7.407v-7.407h1.482v7.407h-1.482z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgRemoveUser;
